<template>
  <div class="coupons">
    <img class="img" :src="url" alt @click="onDetailClick" />
  </div>
</template>

<script>
import API from "./api";
export default {
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.timer)
    next();
  },
  components: {},
  data() {
    return {
      url: "",
      timer: null
    };
  },
  methods: {
    get_pic() {
      API.get_pic(
        {
          type: 2
        },
        res => {
          if (res && res.code) {
            this.url = res.data.alert_pic;
          }
        }
      );
    },
    onDetailClick() {
      this.$router.push({
        name: "activity-detail",
        params: {}
      });
    }
  },
  mounted() {
    this.get_pic();
    this.timer = setTimeout(() => {
      this.onDetailClick();
    }, 3000);
  }
};
</script>

<style scoped lang="scss">
.coupons {
  width: 7.5rem;
  height: 100%;
  overflow: hidden;
  .img {
    width: 7.5rem;
    height: 100%;
  }
}
</style>
